import type { setAssetPath } from '@amp-ui-commerce/cwc-music/dist/components';
import type { defineCustomElement as defineUpsellBannerCE } from '@amp-ui-commerce/cwc-music/dist/components/cwc-music-upsell-banner-web';
import type { defineCustomElement as defineUpsellPersonalCE } from '@amp-ui-commerce/cwc-music/dist/components/cwc-upsell-personal';
import { getBaseUrl } from '@amp/web-apps-utils';

export async function loadSetAssetPath(): Promise<typeof setAssetPath> {
    return (await import('@amp-ui-commerce/cwc-music/dist/components'))
        .setAssetPath;
}

export async function loadDefineUpsellBannerCE(): Promise<
    typeof defineUpsellBannerCE
> {
    return (
        await import(
            '@amp-ui-commerce/cwc-music/dist/components/cwc-music-upsell-banner-web'
        )
    ).defineCustomElement;
}

export async function loadDefineUpsellPersonalCE(): Promise<
    typeof defineUpsellPersonalCE
> {
    return (
        await import(
            '@amp-ui-commerce/cwc-music/dist/components/cwc-upsell-personal'
        )
    ).defineCustomElement;
}

export async function loadMusicUpsellBanner() {
    if (!customElements.get('cwc-music-upsell-banner-web')) {
        const [setAssetPath, defineCustomElement] = await Promise.all([
            loadSetAssetPath(),
            loadDefineUpsellBannerCE(),
        ]);
        setAssetPath(`${getBaseUrl()}/assets/cwc/`), defineCustomElement();
    }
}

export async function loadMusicUpsellPersonal() {
    if (!customElements.get('cwc-upsell-personal')) {
        const [setAssetPath, defineCustomElement] = await Promise.all([
            loadSetAssetPath(),
            loadDefineUpsellPersonalCE(),
        ]);
        setAssetPath(`${getBaseUrl()}/assets/cwc/`), defineCustomElement();
    }
}
